import { render, staticRenderFns } from "./ProfileList.vue?vue&type=template&id=6d94ac4f&scoped=true&"
import script from "./ProfileList.vue?vue&type=script&lang=js&"
export * from "./ProfileList.vue?vue&type=script&lang=js&"
import style0 from "./ProfileList.vue?vue&type=style&index=0&id=6d94ac4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d94ac4f",
  null
  
)

export default component.exports